import React, { useState } from 'react';
import { db } from '../../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { 
  FaStar, 
  FaUtensils, 
  FaUserTie, 
  FaMobileAlt, 
  FaCommentDots, 
  FaPaperPlane, 
  FaTimes,
  FaCheckCircle
} from 'react-icons/fa';
import './Satisfaction.css';

const Satisfaction = ({ setShowSatisfaction }) => {
  const [ratings, setRatings] = useState({
    plats: 0,
    service: 0,
    application: 0,
  });
  const [feedback, setFeedback] = useState('');
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleRatingChange = (category, value) => {
    setRatings({ ...ratings, [category]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (ratings.plats === 0 || ratings.service === 0 || ratings.application === 0) {
      setErrorMessage('Veuillez attribuer une note pour chaque catégorie.');
      return;
    }
  
    try {
      await addDoc(collection(db, 'satisfaction'), {
        ...ratings,
        feedback,
        date: new Date(),
      });
      setSuccessMessage(true);
      setErrorMessage('');
      setTimeout(() => {
        setSuccessMessage(false);
        setShowSatisfaction(false);
      }, 500);
    } catch (error) {
      console.error('Erreur lors de l\'ajout des données de satisfaction:', error);
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'plats':
        return <FaUtensils className="category-icon" />;
      case 'service':
        return <FaUserTie className="category-icon" />;
      case 'application':
        return <FaMobileAlt className="category-icon" />;
      default:
        return <FaStar className="category-icon" />;
    }
  };

  return (
    <div className="satisfaction-container">
      {/* Header */}
      <div className="satisfaction-header">
        <div className="header-content">
          <h2>Merci pour votre commande !</h2>
        </div>
        <p className="satisfaction-subtitle">
          Nous aimerions connaître votre avis pour améliorer notre service
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="satisfaction-form">
        {/* Ratings Section */}
        <div className="ratings-section">
          {[
            { key: 'plats', label: 'Plats' },
            { key: 'service', label: 'Service' },
            { key: 'application', label: 'Application' }
          ].map(({ key, label }) => (
            <div key={key} className="rating-card">
              <div className="rating-header">
                {getCategoryIcon(key)}
                <label className="rating-label">{label}</label>
              </div>
              <div className="stars-container">
                {[1, 2, 3, 4, 5].map((value) => (
                  <FaStar
                    key={value}
                    className={`star ${ratings[key] >= value ? 'selected' : ''}`}
                    onClick={() => handleRatingChange(key, value)}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Feedback Section */}
        <div className="feedback-section">
          <div className="feedback-header">
            <FaCommentDots className="feedback-icon" />
            <label className="feedback-label">Commentaires</label>
          </div>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Partagez vos suggestions ou remarques ici..."
            className="feedback-textarea"
          />
        </div>

        {/* Buttons */}
        <div className="satisfaction-buttons">
          <button type="submit" className="submit-btn">
            <FaPaperPlane className="btn-icon" />
            Envoyer
          </button>
          <button 
            type="button" 
            className="close-btn"
            onClick={() => setShowSatisfaction(false)}
          >
            <FaTimes className="btn-icon" />
            Fermer
          </button>
        </div>
      </form>

      {/* Messages */}
      {errorMessage && (
        <div className="error-message">
          <p>{errorMessage}</p>
        </div>
      )}
      
      {successMessage && (
        <div className="success-message">
          <FaCheckCircle className="success-icon" />
          <p>Merci pour vos retours !</p>
        </div>
      )}
    </div>
  );
};

export default Satisfaction;